/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventLoginAttemptedFromJSON(json) {
    return StreemApiAnalyticEventLoginAttemptedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventLoginAttemptedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'method': !exists(json, 'method') ? undefined : json['method'],
        'successful': !exists(json, 'successful') ? undefined : json['successful'],
        'inviteSid': !exists(json, 'invite_sid') ? undefined : json['invite_sid'],
    };
}
export function StreemApiAnalyticEventLoginAttemptedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'method': value.method,
        'successful': value.successful,
        'invite_sid': value.inviteSid,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventLoginAttemptedMethod;
(function (StreemApiAnalyticEventLoginAttemptedMethod) {
    StreemApiAnalyticEventLoginAttemptedMethod["INVITATION"] = "LOGIN_METHOD_INVITATION";
    StreemApiAnalyticEventLoginAttemptedMethod["SSO"] = "LOGIN_METHOD_SSO";
    StreemApiAnalyticEventLoginAttemptedMethod["USERPASS"] = "LOGIN_METHOD_USER_PASS";
    StreemApiAnalyticEventLoginAttemptedMethod["INVALID"] = "LOGIN_METHOD_INVALID";
})(StreemApiAnalyticEventLoginAttemptedMethod || (StreemApiAnalyticEventLoginAttemptedMethod = {}));
//# sourceMappingURL=StreemApiAnalyticEventLoginAttempted.js.map